import React from "react";
import "./loader.css";

const Loader = () => {
  return (
    <>
      <div className="text-center loader">
        <img src="/img/loader.gif" alt="Loader" />
      </div>
    </>
  );
};

export default Loader;
